import { z } from 'zod';
import { isoTimestamp, severity, uuid } from './primitives.js';
import { monitorHistoryBucket, monitorHistoryBucketSize, monitorHistoryRange, monitorHistoryTotals, monitorStatus, } from './monitors.js';
export const overviewStats = z.object({
    alerts_firing: z.number().int(),
    alerts_acknowledged: z.number().int(),
    alerts_last_24h: z.number().int(),
    by_severity: z.array(z.object({ severity, count: z.number().int() })),
    deliveries_pending: z.number().int(),
    deliveries_failed_24h: z.number().int(),
    delivery_success_rate_24h: z.number().nullable(),
    active_sources: z.number().int(),
    active_channels: z.number().int(),
    /** One bucket per hour for the last 24 hours, oldest first. */
    timeline: z.array(z.object({ bucket: z.string(), count: z.number().int() })),
});
/**
 * Verlauf aller Monitore für die Übersicht. Die Balken oben sind die Summe
 * über alle Monitore, darunter jeder einzeln mit denselben Balkengrenzen —
 * damit ein Ausfall oben sich mit dem Finger nach unten verfolgen lässt.
 */
export const monitorsOverview = z.object({
    range: monitorHistoryRange,
    bucket: monitorHistoryBucketSize,
    from: isoTimestamp,
    to: isoTimestamp,
    buckets: z.array(monitorHistoryBucket),
    totals: monitorHistoryTotals,
    monitors: z.array(z.object({
        id: uuid,
        name: z.string(),
        is_active: z.boolean(),
        status: monitorStatus,
        buckets: z.array(monitorHistoryBucket),
        totals: monitorHistoryTotals,
    })),
});
export const healthResponse = z.object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    checks: z.record(z.string(), z.object({ ok: z.boolean(), detail: z.string().optional() })),
});
//# sourceMappingURL=stats.js.map